export const SIDEBAR_STATE_TYPES = {
  UPDATE_MOBILE_SIDEBAR_VISIBLE: 'UPDATE_MOBILE_SIDEBAR_VISIBLE',
};
